<img src="/assets/loader.gif" class="ajax-loader" alt="Loading...">